export const EVENTS = {
    CANDIDATE_JOINED: 1,
    INTERVIEW_STARTED: 2,
    DISCONNECTED: 3,
    INTERVIEW_FINISHED: 4,
    TERMINATED: 5,
    WINDOW_IN_FOCUS: 6,
    WINDOW_FOCUS_OUT: 7,
    COPY_DETECTED: 8,
    PASTE_DETECTED: 9,
    MULTIPLE_FACES_DETECTED: 10,
    PHONE_DETECTED: 11,
    FACE_NOT_DETECTED: 12,
    WINDOW_RESIZED: 13,
    WEBCAM_CLOSED: 14,
    UNKNOWN_PERSON_DETECTED: 15,
    ANSWER_SUBMITTED_FOR_QUESTION_VAL: 16,
    SKIPPED_QUESTION_VAL: 17,
    SWITCHED_TO_QUESTION_VAL: 18,
    RECORDING_STARTED_FOR_QUESTION_VAL: 19,
    RETAKE_TAKEN_ON_QUESTION_VAL: 20,
    RECORDING_STOPPED_FOR_QUESTION_VAL: 21,
    SCREEN_SHARING_WAS_STOPPED: 22,
    RE_INVITED: 23,
    CONNECTED: 24,
    RAN_TEST_CASES: 25,
    EXTERNAL_MONITOR_ATTACHED: 26,
    EXTERNAL_MONITOR_DETACHED: 27,
    RAN_CODE: 28,
    SWITCHED_TO_SUB_QUESTION_SUBVAL_OF_QUESTION_VAL: 29,
    CLICKED_ON_THE_SPEAKER_ICON_OF_THE_QUESTION: 30,
    TRANSCRIBING_ANSWER: 31,
    CLICKED_ON_THE_KEYBOARD_ICON: 32,
    CLICKED_ON_THE_DONE_BUTTON: 33,
    CLICKED_ON_THE_STOP_BUTTON: 34,
    SPEAKER_S_VOICE_CHANGED: 35,
    ACCESSIBILITY_PANEL_IS_OPEN: 37,
    ACCESSIBILITY_PANEL_IS_CLOSED: 38,
    FULLSCREEN_ENABLED: 39,
    FULLSCREEN_DISABLED: 40,
    TEXT_READER_ENABLED: 41,
    TEXT_READER_DISABLED: 42,
    VOICE_COMMAND_ENABLED: 43,
    VOICE_COMMAND_DISABLED: 44,
    CURSOR_COLOR_CHANGED_TO_WHITE: 45,
    CURSOR_COLOR_CHANGED_TO_BLACK: 46,
    CURSOR_COLOR_CHANGED_TO_DEFAULT: 47,
    READABLE_FONT_ENABLED: 48,
    READABLE_FONT_DISABLED: 49,
    IMAGE_DESCRIPTION_ENABLED: 50,
    IMAGE_DESCRIPTION_DISABLED: 51,
    HIGHLIGHT_LINKS_ENABLED: 52,
    HIGHLIGHT_LINKS_DISABLED: 53,
    HIGHLIGHT_HEADERS_ENABLED: 54,
    HIGHLIGHT_HEADERS_DISABLED: 55,
    TEXT_MAGNIFIER_ENABLED: 56,
    TEXT_MAGNIFIER_DISABLED: 57,
    BACKGROUND_COLOR_CHANGED_TO_ACSVAL: 58,
    HEADING_COLOR_CHANGED_TO_ACSVAL: 59,
    CONTENT_COLOR_CHANGED_TO_ACSVAL: 60,
    FONT_SIZE_CHANGED_TO_ACSVAL: 61,
    WORD_SPACING_CHANGED_TO_ACSVAL: 62,
    LINE_SPACING_CHANGED_TO_ACSVAL: 63,
    COLOR_RESET: 64,
    MONOCHROME_ENABLED: 65,
    MONOCHROME_DISABLED: 66,
    ACCESSIBILITY_RESET: 67,
    PRE_SCREENING_STARTED: 68,
    PRE_SCREENING_COMPLETED: 69,
    AI_ASKED_QUESTION: 70,
    CANDIDATE_RESPONDED: 71,
    INTERVIEW_FINISHED_DELIBERATELY: 72,
    CURRENT_ANSWER_RESET: 73,
    AI_VIDEO_RECORDING_STARTED: 74,
    AI_VIDEO_RECORDING_STOPPED: 75,
    CANDIDATE_LOOKED_AWAY: 76,
    INTERVIEW_REFRESHED: 77,
    CODE_QUES_ASKED_BY_AI: 78,
    CODE_SOLUTION_SUBMITTED: 79,
    AUTO_SUBMIT_QUESTION_DUE_TO_TIMELIMIT: 80,
    ANSWER_SUBMITTED_DUE_TO_RELOAD: 81,
    ENTERED_FULLSCREEN_MODE: 82,
    EXITED_FULLSCREEN_MODE: 83,
    SELECTING_FILE: 84,
    SELECTED_FILE: 85,
    NETWORK_SPEED_DETECTED: 86,
    CAMERA_DEVICE_SELECTED: 87,
    MICROPHONE_DEVICE_SELECTED: 88,
    EXTERNAL_MIC_USAGE: 89,
    PRACTICE_QUESTION_STARTED: 90,
    PRACTICE_QUESTION_COMPLETED: 91,
};

export const PRE_SCREENING_STATUS = {
    INVITED: 0,
    QUALIFIED: 1,
    DISQUALIFIED: 2,
};

export const STAGE = {
    SHOW_BEFORE_INTERVIEW: 1,
    SHOW_WELCOME: 2,
    SHOW_TRY_PRACTICE_QUESTION: 3,
    SHOW_START_PRACTICE_QUESTION: 4,
    SHOW_PRACTICE_QUESTION: 5,
    SHOW_START_PROCTORING: 6,
    SHOW_INSTRUCTION: 7,
    SHOW_INTERVIEW_QUESTION: 8,
    SHOW_EXIT: 9,
};

export const ID_VERIFICATION_STATUS = {
    PENDING: 0,
    COMPLETED: 1,
    FAILED: 2,
    CUSTOM: 3,
};

export const INTERVIEW_TYPE = {
    DEFAULT: "1",
    FLEXIBLE: "2",
    TIMED: "3",
};

export const TESTIMONIAL_STEPS = {
    SHARE_EXPERIENCE: 1,
    LOGIN: 2,
    CREATE_TESTIMONIAL: 3,
    VIDEO_RECORDING_SCREEN: 4,
    THANKYOU: 5,
};

export const INTERVIEW_MODE = {
    STANDARD: "0",
    INTEGRATION: "1",
    MOCK: "2",
};

export const CONNECTION_STATUS = {
    CANDIDATE_JOINED: 1,
    INTERVIEW_STARTED: 2,
    DISCONNECTED: 3,
    INTERVIEW_FINISHED: 4,
    TERMINATED: 5,
};

export const INTERVIEW_THEME = {
    FIRST: "2",
    SECOND: "1",
};

export const QUESTION_TYPES = {
    VIDEO: 1,
    MCQ_SINGLE: 2,
    ESSAY: 3,
    AUDIO: 4,
    SLIDE: 5,
    CODING: 9,
    DOCUMENT: 10,
    TRUE_FALSE: 11,
    FILL_BLANKS: 12,
    MATCHING: 13,
    SCENARIO: 14,
    MCQ_MULTI: 15,
    TYPING: 16,
    FLOWCHART: 17,
    GAME: 18,
    EXCEL: 19,
};

export const ID_VERIFICATION_MODE = {
  SUMSUB: 1,
  AUTH_ID: 0
}
